import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { BUDGET_RECURRENCE as _BUDGET_RECURRENCE, BILLING_TYPE as _BILLING_TYPE, BUDGET_TYPE as _BUDGET_TYPE } from 'src/boot/constants';
import TimeInput from 'src/components/Pickers/TimeInput';
import budgetManagement from 'src/mixins/budget-management';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [budgetManagement],
  components: {
    TimeInput: TimeInput,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    value: {
      type: Object
    },
    billingType: {
      type: String,
      required: true
    },
    project: {
      type: Object
    }
  },
  watch: {
    billingType: function billingType(val) {
      if (this.budgetType === 'monetary') {
        if (val === _BILLING_TYPE.FIXED_FEE || val === _BILLING_TYPE.TIME_MATERIAL) {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            type: _BUDGET_TYPE.REVENUE
          }));
        } else if (val === _BILLING_TYPE.NOT_BILLABLE) {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            type: _BUDGET_TYPE.COST
          }));
        }
      }
    },
    'budget.recurrence': function budgetRecurrence(val, oldVal) {
      if (this.budgetType !== 'none') {
        if (this.budget.interval > 6 && oldVal) {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            interval: 1
          }));
        }
      }
    },
    'budget.interval': function budgetInterval(val, oldVal) {
      if (val < 0) {
        this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
          interval: 1
        }));
      }
    }
  },
  computed: {
    BUDGET_TYPE: function BUDGET_TYPE() {
      return _BUDGET_TYPE;
    },
    BUDGET_RECURRENCE: function BUDGET_RECURRENCE() {
      return _BUDGET_RECURRENCE;
    },
    BILLING_TYPE: function BILLING_TYPE() {
      return _BILLING_TYPE;
    },
    budget: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    sendBudgetThresholdEmail: {
      get: function get() {
        return !!this.budget.alert_threshold;
      },
      set: function set(val) {
        if (!val) {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            alert_threshold: 0
          }));
        } else {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            alert_threshold: 75
          }));
        }
      }
    },
    budgetType: {
      get: function get() {
        if (!this.budget) return 'none';
        if (this.budget.type === 'time') return 'time';else return 'monetary';
      },
      set: function set(val) {
        var _this = this;

        if (val === 'none') {
          this.budget = null;
        } else {
          if (!this.budget) {
            this.budget = {
              budget_minutes: 0,
              budget_amount: 0,
              recurrence: 0,
              interval: 1,
              alert_threshold: null,
              includes_expenses: false
            };
          }

          this.$nextTick(function () {
            if (val === 'time') {
              _this.$emit('input', _objectSpread(_objectSpread({}, _this.budget), {}, {
                type: _BUDGET_TYPE.TIME
              }));
            } else if (_this.billingType === _BILLING_TYPE.NOT_BILLABLE) {
              _this.$emit('input', _objectSpread(_objectSpread({}, _this.budget), {}, {
                type: _BUDGET_TYPE.COST
              }));
            } else {
              _this.$emit('input', _objectSpread(_objectSpread({}, _this.budget), {}, {
                type: _BUDGET_TYPE.REVENUE
              }));
            }
          });
        }
      }
    },
    budgetRecurrence: {
      get: function get() {
        return !!this.budget.recurrence;
      },
      set: function set(val) {
        if (!val) {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            recurrence: 0
          }));
        } else {
          this.$emit('input', _objectSpread(_objectSpread({}, this.budget), {}, {
            recurrence: 2,
            interval: 1
          }));
        }
      }
    },
    disabled: function disabled() {
      return !this.me.account.hasFeatureAccess('fixed_fee_projects') && this.project.billing_type === _BILLING_TYPE.FIXED_FEE || !this.me.account.hasFeatureAccess('billables') && this.project.billing_type === _BILLING_TYPE.TIME_MATERIAL;
    },
    budgetAmountDisabled: function budgetAmountDisabled() {
      return this.billingType === _BILLING_TYPE.NOT_BILLABLE && !this.me.is_owner;
    },
    canIncludeExpenses: function canIncludeExpenses() {
      return this.budget.type === _BUDGET_TYPE.COST || this.billingType === _BILLING_TYPE.TIME_MATERIAL && this.budget.type === _BUDGET_TYPE.REVENUE || this.billingType === _BILLING_TYPE.FIXED_FEE;
    }
  },
  methods: {
    onItemClick: function onItemClick(feature) {
      if (feature && !this.me.account.hasFeatureAccess(feature)) {
        this.$refs[feature + 'Upgrade'].showTooltip();
      }
    }
  }
};